/**
 * Minimal strategic-framework category map for the participant view.
 * Mirrors apps/web/src/lib/frameworkConfig.ts (keys MUST match — they are
 * stored on submissions). The zoom app builds standalone (no workspace
 * imports on Railway), hence the local copy of just what's needed.
 */

export interface FrameworkCategory {
  key: string;
  label: string;
}

const FRAMEWORKS: Record<string, FrameworkCategory[]> = {
  swot: [
    { key: 'strength', label: 'Strength' },
    { key: 'weakness', label: 'Weakness' },
    { key: 'opportunity', label: 'Opportunity' },
    { key: 'threat', label: 'Threat' },
  ],
  pestle: [
    { key: 'political', label: 'Political' },
    { key: 'economic', label: 'Economic' },
    { key: 'social', label: 'Social' },
    { key: 'technological', label: 'Technological' },
    { key: 'legal', label: 'Legal' },
    { key: 'environmental', label: 'Environmental' },
  ],
  sixhats: [
    { key: 'white', label: 'White Hat' },
    { key: 'red', label: 'Red Hat' },
    { key: 'black', label: 'Black Hat' },
    { key: 'yellow', label: 'Yellow Hat' },
    { key: 'green', label: 'Green Hat' },
    { key: 'blue', label: 'Blue Hat' },
  ],
  fiveforces: [
    { key: 'rivalry', label: 'Competitive Rivalry' },
    { key: 'supplier_power', label: 'Supplier Power' },
    { key: 'buyer_power', label: 'Buyer Power' },
    { key: 'substitution', label: 'Threat of Substitution' },
    { key: 'new_entry', label: 'Threat of New Entry' },
  ],
};

export function getFrameworkCategories(
  frameworkType?: string | null,
): FrameworkCategory[] {
  return FRAMEWORKS[frameworkType || 'swot'] || FRAMEWORKS.swot;
}
